import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Box, Grid } from '@mui/material';
import emailjs from '@emailjs/browser';

// Initialize EmailJS with your User ID
emailjs.init('jRgBYQzFLFdLigATx');
const FeedbackPage = () => {
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleFeedbackChange = (event) => {
    setFeedback(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Prepare the email data
    const emailData = {
      from_email: email,
      message: feedback,
    };

    setIsSubmitted(true);
    
    
    // Send the email using EmailJS
    emailjs
      .send('service_2y70e5b', 'template_nnml4nk', emailData)
      .then(
        (result) => {
          // Clear the form fields
          setEmail('');
          setFeedback('');
          setIsSubmitted(true); // Set isSubmitted to true
        },
        (error) => {
        }
      );
  };

  const handleReset = () => {
    setIsSubmitted(false);
  };

  return (
    <Container maxWidth="lg">
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography variant="h4" component="h1">
              Feedback Form
            </Typography>
            <Typography variant="body1" paragraph>
              Welcome to Clip Thoughts. We built this website to help you take better notes and easily revisit important sections while watching videos on YouTube, whether it's podcasts, tutorials, lectures, or any other type of content.
            </Typography>
            <Typography variant="body1" paragraph>
              We know that videos are packed with valuable information, but it can be challenging to remember everything. With Clip Thoughts, you can bookmark key moments, take notes, and loop through specific segments as many times as needed.
            </Typography>
            <Typography variant="body1" paragraph>
              Our website is still in its early stages, but we have big plans to introduce more features in the future. If you have any ideas or suggestions, please let us know through our feedback form. Your input will help shape Clip Thoughts into the ultimate tool for learning from videos.
            </Typography>
            <Typography variant="body1" paragraph>
              Stay tuned and thank you for using Clip Thoughts!
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            {isSubmitted ? (
              <>
                <Typography variant="body1" gutterBottom>
                  Thank you for your feedback! We appreciate your valuable input.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleReset}
                  fullWidth
                >
                  Go Back
                </Button>
              </>
            ) : (
              <form onSubmit={handleSubmit}>
                <TextField
                  label="Email(Optional)"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  value={email}
                  defaultValue="optional@xyz.com"
                  onChange={handleEmailChange}
                />
                <TextField
                  label="Feedback"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={4}
                  margin="normal"
                  value={feedback}
                  onChange={handleFeedbackChange}
                />
                <Button type="submit" variant="contained" color="primary" fullWidth>
                  Submit
                </Button>
              </form>
            )}
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default FeedbackPage;